import React, { PureComponent } from 'react';
import { Button, Cell, Grid } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../component/ApiRequestService';
import DynamicData from '../component/DynamicData';
import SFHelpTextTable from '../component/SFHelpTextTable';
import Properties from '../component/Properties';
import SecureShow from '../component/SecureShow';
//import Instructor from './instructors';
import Semester from '../component/Semester';
import ServiceStatusTable from '../component/ServiceStatusTable';
import TimeZone from '../component/TimeZone';
//import Universities from  '../component/NewUniversityForm';
import { AppProperties } from '../common/function';
import WhitelistTable from '../component/WhitelistTable';



export default class SettingsPage extends PureComponent  {
    appProperties = AppProperties();
    baseFolder = this.appProperties.baseFolder;
    constructor(props){
        super(props);

        this.state={
            archiveInProgress:false,
            archiveQBInProgress:false,
            loadingActivities:true,
            loadingTechTrouble: true,            
            calAvgRespTime:false,
        };
        this.recentActivities = [];
       
    }

    componentWillMount(){
        // console.debug("suffix ",universityPrefix)
    }

    //Event Hooks
    componentDidMount(){
        this.getRecentActivities();
    }




    //API Requests

    requestArchive = async (semesterID) => {
        this.setState({archiveQBInProgress:true});
        try{
            
            let payload = {
                semesterID :semesterID,
            }
            let archiveResponse = await ApiRequestService({
            method: 'post',
            url:'archive',
            data: payload
            })
            if(archiveResponse.data !== undefined && archiveResponse.data !== null){
                if(archiveResponse.data.status === 0){
                    NotificationManager.success("Archive Request has been Submitted","Success",5000);
                }else if (archiveResponse.data.message !== undefined &&  archiveResponse.data.message !== null ) {
                    NotificationManager.error(archiveResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive Request failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive Request failed with Unknown Server Error","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({archiveQBInProgress:false});
        }    
    }

    //API Call to Initiate Question Bank Archive
    requestQuestionBankArchive = async () => {
        this.setState({archiveInProgress:true});
        try{
            
            let archiveResponse = await ApiRequestService({
            method: 'post',
            url:'archiveQuestionBank',
            data: ''
            })
            if(archiveResponse.data !== undefined && archiveResponse.data !== null){
                if(archiveResponse.data.status === 0){
                    NotificationManager.success("Archive Request has been Submitted","Success",5000);
                }else if (archiveResponse.data.message !== undefined &&  archiveResponse.data.message !== null ) {
                    NotificationManager.error(archiveResponse.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Archive Request failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Archive Request failed with Unknown Server Error","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({archiveInProgress:false});
        }    
    }
    //API Call to Initiate Average Response Time Calcuation
    requestAvgRespTimeCal = async () => {
        this.setState({calAvgRespTime:true});
        try{
            
            let resp = await ApiRequestService({
            method: 'post',
            url:'CalAvgRespTime',
            data: ''
            })
            if(resp.data !== undefined && resp.data !== null){
                if(resp.data.status === 0){
                    NotificationManager.success("Request Successful","Success",5000);
                }else if (resp.data.message !== undefined &&  resp.data.message !== null ) {
                    NotificationManager.error(resp.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Request failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Request failed with Unknown Server Error","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({archiveInProgress:false});
        }    
    }

    requestQuestionAvgRespTimeCal = async () => {
        this.setState({calAvgRespTime:true});
        try{
            
            let resp = await ApiRequestService({
            method: 'post',
            url:'CalAvgRespTimeForQuestion',
            data: ''
            })
            if(resp.data !== undefined && resp.data !== null){
                if(resp.data.status === 0){
                    NotificationManager.success("Request Successful","Success",5000);
                }else if (resp.data.message !== undefined &&  resp.data.message !== null ) {
                    NotificationManager.error(resp.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Request failed with Unknown Server Error","Error",5000);
                }
            }else{
                NotificationManager.error("Request failed with Unknown Server Error","Error",5000);
            }
            
        }catch(err){
           
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({archiveInProgress:false});
        }    
    }
    

    //API Call to Get Recent Activity Status
    getRecentActivities = async() =>{
        this.setState({loadingActivities:true});
        try{
            
            let activityResp = await ApiRequestService({
            method: 'post',
            url:'serviceStatus',
            data: ''
            })
            if(activityResp.data !== undefined && activityResp.data !== null){
                if(activityResp.data.status === 0 &&  activityResp.data.data){
                    this.recentActivities = activityResp.data.data;
                }else if (activityResp.data.message !== undefined &&  activityResp.data.message !== null ) {
                    NotificationManager.error(activityResp.data.message,"Error",5000);
                }else{
                    NotificationManager.error("Getting Recent Activities Failed with Unknown Error","Error",5000);
                }
            }else{
                NotificationManager.error("Getting Recent Activities Failed with Unknown Error","Error",5000);
            }
            
        }catch(err){
            NotificationManager.error(err,"Error",5000);
        }finally{
            this.setState({loadingActivities:false});
         }
    }

    fetchInstructorPage = () => {
        console.debug("fetch instructor page")
        browserHistory.push(this.baseFolder + 'Instructors')      
    };

    fetchAdminPage = () => {
        browserHistory.push(this.baseFolder + 'Admins')  
    }
    handleArchiveClick = (semesterID) =>{
        this.requestArchive(semesterID) 
    }
    render(){
        
        return (<SecureShow targetRole={2}><SettingsGrid 
                                            statusList={this.recentActivities}
                                            {...this.props}
                                            loadingActivities={this.state.loadingActivities} 
                                            archiveInProgress={this.state.archiveInProgress} 
                                            archiveQBInProgress={this.state.archiveQBInProgress}
                                            onArchiveClick={this.handleArchiveClick}
                                            onQuestionBankArchiveClick={this.requestQuestionBankArchive}
                                            onRespTimeCalReq={this.requestAvgRespTimeCal}
                                            onQuestionRespTimeCalReq={this.requestQuestionAvgRespTimeCal}
                                            getRecentActivities={this.getRecentActivities}
                                            fetchInstructorPage={this.fetchInstructorPage}
                                            fetchAdminPage={this.fetchAdminPage}
                                            /></SecureShow>
        )}
}

var SettingsGrid = (props) => {
    const handleArchiveClick =(semesterID) =>{
        props.onArchiveClick(semesterID)   
    }
    return <Grid gutter={1} className='settings-grid'>
                <Cell size={8}><h1>Settings</h1></Cell>
                <Cell size ={6}>
                <Cell size={12}>
                    <InstructorCard  key="InstructorWidget" popFromBreadCrumbs={props.popFromBreadCrumbs}
                     replaceBreadCrumb={props.replaceBreadCrumb}
                     fetchInstructorPage={props.fetchInstructorPage}
                     />
                    {}
                </Cell>
                <Cell size={12}>
                    <AdminCard key="AdminWidget" popFromBreadCrumbs={props.popFromBreadCrumbs}
                     replaceBreadCrumb={props.replaceBreadCrumb}
                     fetchAdminPage={props.fetchAdminPage}
                     />
                    {/*<Instructor key="InstructorWidget" popFromBreadCrumbs={props.popFromBreadCrumbs}
                     replaceBreadCrumb={props.replaceBreadCrumb}/>*/}
                </Cell>
                </Cell>
                <Cell size ={6}>
                    <Semester archiveSemester={handleArchiveClick}/>
                </Cell>
                <Cell size ={6}>
                    {props.archiveQBInProgress?
                                <BeatLoader    loading={props.archiveInProgress}  color={'#bb0000'} size={10} />
                                :
                                <ArchiveQuestionBankButton onClick={props.onQuestionBankArchiveClick}/>
                    } 
                   
                </Cell>
                <Cell size={6}>
                    <SubCatTimeButtom onClick={props.onRespTimeCalReq}/>
                </Cell>
                <Cell size={6}>
                    <QuestionTimeButtom onClick={props.onQuestionRespTimeCalReq}/>
                </Cell>
                <Cell size={12}>
                    <WhitelistTable />  
                </Cell>
                <Cell size={12}>
                    <SFHelpTextTable />
                </Cell>
                <Cell size={6}>
                    <TimeZone/>
                </Cell>
                
                {/*universityPrefix === "asu" ? 
                    <Cell size={12}>
                        <Universities/> 
                    </Cell>
                    : 
                    ""
                */}
                {/*<Cell size={6}>
                    <QuestionSync/>
                </Cell>*/}
                <Cell size={12} >
                    <ServiceStatusTable loading={props.loadingActivities} statusList={props.statusList} 
                        onRefresh={props.getRecentActivities}/>
                </Cell>
                <Cell size={12}>
                    <DynamicData 
                        text = "Technical Troubleshooting Text"
                        type = {1}
                        />        
                </Cell>
                <Cell size={12}>
                    <DynamicData 
                        text = "About Page for Students Text"
                        type = {2}
                        />
                </Cell>
                <Cell size={12}>
                    <DynamicData 
                        text = "FAQ Text"
                        type = {3}
                        />
                </Cell>
                <Cell size={12}>
                    <DynamicData 
                        text = "About Page For Admin Text"
                        type = {4}
                        />
                </Cell>
            </Grid>
}


var ArchiveQuestionBankButton = (props) => {
    return <fieldset className='archive-btn-field-set'>
                <legend>*Archive*</legend>
                <ul className='archive-btn-list'>
                    <li>Archival will make a copy all the Questions.</li> 
                    <li>The archived data can be found in the Archive menu</li>
                </ul>
                <Button className="archive-button" primary raised onClick={props.onClick}>Archive Question Bank</Button>
            </fieldset>


}



var SubCatTimeButtom  = (props) => {
    return <fieldset className='archive-btn-field-set'>
                <legend>*Category and SubCategory Reponse Time*</legend>
                <ul className='archive-btn-list'>
                    <li>Time calculation runs automatically every monday night and takes around 10-15 minutes to complete. The status will be updated in the Activity Status Table. If you want to trigger it manually, click the button below.</li>
                </ul>
                <Button className="archive-button" primary raised onClick={props.onClick}>Calculate Response Time</Button>
            </fieldset>
}
var QuestionTimeButtom  = (props) => {
    return <fieldset className='archive-btn-field-set'>
                <legend>*Question Reponse Time*</legend>
                <ul className='archive-btn-list'>
                    <li>Time calculation runs automatically every monday night and takes around 10-15 minutes to complete. The status will be updated in the Activity Status Table. If you want to trigger it manually, click the button below.</li>
                </ul>
                <Button className="archive-button" primary raised onClick={props.onClick}>Calculate Response Time</Button>
            </fieldset>
}
var InstructorCard  = (props) => {
    return <fieldset className='archive-btn-field-set'>
                <legend>*Instructors*</legend>
                <ul className='archive-btn-list'>
                    <li>Click on the button below to view, add and edit Instructors.</li>
                </ul>
                <Button className="archive-button" primary raised onClick={props.fetchInstructorPage}>Instructors</Button>
            </fieldset>
}

var AdminCard = (props) => {
    return <fieldset className='archive-btn-field-set'>
                <legend>*Administrators*</legend>
                <ul className='archive-btn-list'>
                    <li>Click on the button below to view, add and edit Administrators.</li>
                </ul>
                <Button className="archive-button" primary raised onClick={props.fetchAdminPage}>Administrators</Button>
            </fieldset>
}